var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87.086 28.527v62.461c0 3.6055-3.0039 6.6055-6.6055 6.6055h-60.66c-3.9023 0-6.9062-3.0039-6.9062-6.6055v-62.461h-7.207v-13.215h20.723v-6.3047c0-3.6055 2.7031-6.6055 6.3047-6.6055h34.535c3.6055 0 6.6055 3.0039 6.6055 6.6055v6.3047h20.422v13.215zm-54.055 7.207h7.5078v40.539h-7.5078zm27.027 0h7.5078v40.539h-7.5078zm-13.512 0h7.5078v40.539h-7.5078zm-13.215-20.422h33.633v-6.0078h-33.633zm44.746 13.215h-55.855v60.059h55.855z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.0135489e101904ee0fb5354c4bc20243.svg";
export { ForwardRef as ReactComponent };